module.exports = require("./dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** jquery (bower component)
 ** module id = 13
 ** module chunks = 0
 **/